import { Icon } from 'semantic-ui-react'

export const _golfRecordTypes = {
  tournament: 'tournament',
  full: 'full',
}

export const GolferRecords = ({ golfer, golfer_partners, selectedRoundType, golferRecordType }) => {

  const { golferKey } = golfer ?? {}
  const golferRecord = golfer_partners?.[golferKey]
  const { partners } = golferRecord ?? {}
  const divs = []

  if (partners) {
    _.forEach(partners, (partner) => {
      const { firstName, lastName, rounds } = partner ?? {}
      if (rounds) {
        _.forEach(rounds, (round, roundKey) => {
          const allow = selectedRoundType ? selectedRoundType === roundKey : true
          if (allow) {
            const { record } = round ?? {}
            let iconColor = 'grey'
            switch (golferRecordType) {
              case _golfRecordTypes.full:
                if (record.wins > record.losses) {
                  iconColor = 'green'
                } else if (record.losses > record.wins) {
                  iconColor = 'red'
                } else if (record.wins === record.losses) {
                  iconColor = 'blue'
                }
                break;
              case _golfRecordTypes.tournament:
                if (record.wins === 1) {
                  iconColor = 'green'
                } else if (record.losses === 1) {
                  iconColor = 'red'
                } else if (record.ties === 1) {
                  iconColor = 'blue'
                }
                break;
            }

            const _title = `${_.startCase(roundKey)}: ${firstName} ${lastName}`
            const _title_full = firstName + ' ' + lastName + ': ' + record.wins + '/' + record.losses + '/' + record.ties + '\n'
            divs.push(
              <div style={{ padding: '.5em', backgroundColor: 'var(--off-black-2)', marginBottom: '.5em', borderRadius: '8px', display: 'flex', justifyContent: 'space-between' }}>
                <div>{_title_full}</div>
                <Icon name={'check circle'} color={iconColor} />
              </div>
            )
          }

        })
      }
    })
  }

  return divs

}
